import {scrollToEl} from "../utility/utils";

export default function smoothScrollAnchorLinks(){
    // Smooth Scrolling Anchor links / Prevent Default on href="#" links
    document.addEventListener(
        "click",
        function (e) {
            // loop parent nodes from the target to the delegation node
            for (let target = e.target; target && target !== this; target = target.parentNode) {
                if (target.matches("a, button")) {
                    const href = target.getAttribute("href");
                    const dataAttrTarget = target.getAttribute('data-scroll-target');
                    if (/^#/.test(href) || dataAttrTarget) {
                        const targetString = dataAttrTarget ? dataAttrTarget : href;
                        const hash = targetString.substring(targetString.indexOf("#"));
                        const hashTarget = document.getElementById(hash.substring(1));
                        if (hash !== "#" && hashTarget && !hashTarget.classList.contains('modal')) {
                            e.preventDefault();
                            target.blur();
                            scrollToEl(hashTarget);
                        } else if (hash === "#") {
                            e.preventDefault();
                            target.blur();
                        }
                    }
                    break;
                }
            }
        },
        false
    );
}